import { Box, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import PerformanceChart from "./PerformanceChart";
import ProductInsights from "./ProductInsights";
import OverviewCardSection from "./OverviewCardSection/OverviewCardSection";


function HomeDashboardNew() {
  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );


  return (
    <div
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      {/* ------------------ HEADER ------------------------ */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Overview
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Monitor performance insights to spot growth opportunities and
            optimize results.
          </Typography>
        </Box>
        {/* 
        <Box sx={{ display: "flex", gap: 1 }}>
          <Header showOnlyCalendar={true} />
        </Box> */}
        
      </Box>

      {/* -------------------------------------------------- */}
      {/* Overview Cards */}
      {/* -------------------------------------------------- */}
      <OverviewCardSection />

      {/* Performance Analysis */}
      <PerformanceChart />

      {/* Product Insights */}
      <ProductInsights
        key={"product-insights-key"}
      />
    </div>
  );
}

export default HomeDashboardNew;
